<template>
  <section
    v-if="!$params.iframe && block.content.links.length"
    v-track:impression="{
      event: `homepage:popularDestinationLinksImpression`,
      params: { pos: useRoute().path },
    }"
    class="container-fluid-lg"
  >
    <h2 class="mb-6 text-2xl font-medium">
      {{ $t(`${trPrefix}searchTeaser`) }}
    </h2>

    <div class="-ml-2 flex flex-row flex-wrap items-center gap-y-2">
      <WebccLink
        v-for="(item, i) in block.content.links"
        :key="i"
        :to="item.href"
        class="border-r-2 px-2 last:border-r-0"
        @click="
          useTracking().handlers?.homepage.popularDestinationLinksClick(
            item.label,
            useRoute().path,
          )
        "
      >
        {{ item.label }}
      </WebccLink>
    </div>
  </section>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.views.PageHome.'

defineProps<{
  block: Block<SEOLinksBlockContent>
}>()
</script>
